enum CycleMeasurement {
  Celsius = 'Celsius',
  Fahrenheit = 'Fahrenheit',
}

export default CycleMeasurement;
